import { TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ComparisonTooltip.css';

interface IComparisonTooltipProps {
  content: string;
  children?: React.ReactNode;
}

export const ComparisonTooltip: React.FC<IComparisonTooltipProps> = ({ children, content }) => {
  return (
    <TooltipDesktop theme="black" placement="top" title={<div className={styles['container']}>{content}</div>}>
      <div>{children}</div>
    </TooltipDesktop>
  );
};
